import DatePicker from "react-datepicker";
import { FC } from "react";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import { useDispatch } from "react-redux";
import { selectCheckIn, selectCheckOut, setCheckIn, setCheckOut } from "application/features/search/searchSlice";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


export interface StayDatesRangeInputProps {
  className?: string;
  onChange?: (dates: [Date | null, Date | null]) => void;
}

const StayDatesRangeInput: FC<StayDatesRangeInputProps> = ({
  className = "",
  onChange,
}) => {

  const { t, ready } = useTranslation("translation");

  const dispatch = useDispatch();

  const checkin = useSelector(selectCheckIn)
  const checkout = useSelector(selectCheckOut)

  const onChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    dispatch(setCheckIn(start));
    dispatch(setCheckOut(end));
    if (onChange) {
      onChange(dates);
    }
  };

  if (!ready) return null;

  return (
    <div>
      <div className="p-5">
        <span className="block font-semibold text-xl sm:text-2xl">
          {t("translation:search.common.leaveWhen")}
        </span>
      </div>
      <div
        className={`relative flex-shrink-0 flex justify-center z-10 py-5 ${className} `}
      >
        <DatePicker
          onChange={onChangeDate}
          startDate={checkin}
          endDate={checkout}
          selectsRange
          monthsShown={1}
          showPopperArrow={false}
          locale={navigator.language}
          inline
          renderCustomHeader={(p) => <DatePickerCustomHeaderTwoMonth {...p} />}
          renderDayContents={(day, date) => (
            <DatePickerCustomDay dayOfMonth={day} date={date} isAvailable />
          )}
        />
      </div>
    </div>
  );
};

export default StayDatesRangeInput;
